import { render, staticRenderFns } from "./PreviousViews.vue?vue&type=template&id=dacc57d8&scoped=true"
import script from "./PreviousViews.vue?vue&type=script&lang=js"
export * from "./PreviousViews.vue?vue&type=script&lang=js"
import style0 from "./PreviousViews.vue?vue&type=style&index=0&id=dacc57d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacc57d8",
  null
  
)

export default component.exports